export default __webpack_public_path__ + "static/media/project1-p2.ee483a43.png";